import { render, staticRenderFns } from "./subordinate-management.vue?vue&type=template&id=05ac8b79&scoped=true&"
import script from "./subordinate-management.vue?vue&type=script&lang=js&"
export * from "./subordinate-management.vue?vue&type=script&lang=js&"
import style0 from "./subordinate-management.vue?vue&type=style&index=0&id=05ac8b79&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ac8b79",
  null
  
)

export default component.exports